<mat-card appearance="outlined" class="card">
  <div class="library-layout">
    <div class="library-controls">
      <button
        matButton="elevated"
        color="primary"
        (click)="loadDocumentsFromServer()"
        class="app-panel-button"
        i18n
        [disabled]="libraryLoaded === true"
      >
        Load library from server
      </button>
      <button
        matButton="elevated"
        (click)="clearRefresh()"
        class="app-panel-button"
        i18n
        [disabled]="libraryLoaded === null"
      >
        Clear and Refresh
      </button>
    </div>

    @if (libraryLoaded) {
    <div class="library-panel">
      <app-library-documents-tree [libraryType]="LibraryT.PUBLIC"
       />
    </div>
    <div class="library-panel">
      <app-library-documents-tree [libraryType]="LibraryT.PERSONAL"
       />
    </div>
    } @else {
    <div class="library-empty">
      <h2 i18n>Library not loaded</h2>
    </div>
    }
  </div>
</mat-card>
